"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var template_1 = require("../template");
var path_1 = require("path");
var toml_1 = __importDefault(require("@tauri-apps/toml"));
var fs_1 = require("fs");
var lodash_1 = require("lodash");
module.exports = function (args) {
    var _a;
    var injectResult = template_1.inject(args.directory, 'all', {
        force: args.force,
        logging: args.logging,
        tauriPath: args.tauriPath
    }, args.customConfig);
    if (args.appName) {
        var manifestPath = path_1.resolve(args.directory, 'src-tauri/Cargo.toml');
        var cargoManifest = toml_1.default.parse(fs_1.readFileSync(manifestPath).toString());
        var binName = lodash_1.kebabCase(args.appName);
        cargoManifest.package.name = binName;
        cargoManifest.package['default-run'] = binName;
        if ((_a = cargoManifest.bin) === null || _a === void 0 ? void 0 : _a.length) {
            cargoManifest.bin[0].name = binName;
        }
        fs_1.writeFileSync(manifestPath, toml_1.default.stringify(cargoManifest));
    }
    return injectResult;
};
